<template>
  <div class="formulaList">
    <div class="left">
      <FormulaListLeft ref="formulaListLeft" @getPrescriptionId="getPrescriptionId"></FormulaListLeft>
    </div>
    <div class="content">
      <FormulaListCenter ref="content" v-loading="contentLoading" :prescriptionId="prescriptionId" :detail="detail" @refreshList="refreshList" @getDetail="getDetail"></FormulaListCenter>
    </div>
    <div class="right">
      <FormulaListRight :orderId="detail.orderId" :list="detail.operateLogs" :imgList="imgList"></FormulaListRight>
    </div>
  </div>
</template>

<script>
import { formulaDetail } from "@/api/formula";
import FormulaListLeft from "./components/FormulaListLeft";
import FormulaListCenter from "./components/FormulaListCenter";
import FormulaListRight from "./components/FormulaListRight";
import { isNull } from '@/utils/validateBase';
import { prescriptionDTO } from '@/DTO/index'
export default {
  name: "FormulaList",
  components: {
    FormulaListLeft,
    FormulaListCenter,
    FormulaListRight
  },
  data() {
    return {
      prescriptionId: "", // 配方id
      contentLoading: false,
      detail: {
        patientInfo: {},
        orderCaseProjectRecipeResp: {},
        drugInfos: [],
        operateLogs: [],
        deliveryInfo: {}
      },
      imgList:[]
    };
  },
  methods: {
    // 获取配方单id
    getPrescriptionId(prescriptionId) {
      if(isNull(prescriptionId)){ 
        this.detail={
          patientInfo: {},
          orderCaseProjectRecipeResp: {},
          drugInfos: [],
          operateLogs: [],
          deliveryInfo: {}
        }
        return;
      }
      this.prescriptionId = prescriptionId;
      this.getDetail();
    },
    // 获取配方单详情
    async getDetail() {
      this.contentLoading = true;
      let res = await formulaDetail({ prescriptionId: this.prescriptionId });
      this.contentLoading = false;
      if (res.code === 200) {
        this.detail = res.data;
        this.detail.operateLogs = (res.data.operateLogs || []).map(item => ({
          ...item,
          operateData: item.operateData ? JSON.parse(item.operateData) : item.operateData
        }))
        this.getPrecreiptionImg(res.data.orderId)
        this.$refs.content.getTransportInfo()
        this.$refs.content.queryHospDrug(this.detail.drugInfos)
      }else{
        this.detail={
          patientInfo: {},
          orderCaseProjectRecipeResp: {},
          drugInfos: [],
          operateLogs: [],
          deliveryInfo: {}
        }
      }
    },
	//收方成功 flag 是否清除当前选中id
	async refreshList(flag = false, callback = () => {}){
    if (flag) { 
      this.$refs.formulaListLeft.user.active ='' 
      this.$refs.formulaListLeft.refreshData();
    } else {
      this.$refs.formulaListLeft.refreshData();
      await this.getDetail();
      if (callback) {
        callback();
      }
    }
	},
  //获取处方图片
    async getPrecreiptionImg(orderId){
      let {code,data} = await prescriptionDTO.getPrecreiptionImg({orderId})
      if(code==200){
        this.imgList = isNull(data.images) ? [] : data.images.split(',')
      }
    }
  }
};
</script>

<style lang="less" scoped>
.formulaList {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.left {
  box-sizing: border-box;
  flex-shrink: 0;
  width: 300px;
  height: 100%;
  background-color: #ffffff;
  border-right: 1px solid #e0e0e0;
  overflow: hidden;
}

.content {
  box-sizing: border-box;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.right {
  box-sizing: border-box;
  flex-shrink: 0;
  width: 300px;
  height: 100%;
  background-color: #ffffff;
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
}
</style>
